// System modules
import { NgModule }      from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { FooterComponent } from './footer.component';
import { CommonModule } from '@angular/common';
// Material modules
import { MatButtonModule} from '@angular/material/button';


 const footerRoutes: Routes = [
    {
        path: '',
        component: FooterComponent,
    }
];


@NgModule({
  imports:      [   CommonModule, 
                    MatButtonModule,
                    RouterModule.forChild(footerRoutes),
                  ], 
  declarations: [ 
                    FooterComponent,
                ], 
  exports:      [ FooterComponent ], 
  providers:    [  ]
})

export class FooterModule { }
